/* ============================================================
   Toast — minimal, announced to assistive tech, one at a time.
   ============================================================ */

let active = null;
let timer = null;

export function toast(message, { duration = 3200, tone = 'neutral' } = {}) {
  dismiss();

  const node = document.createElement('div');
  node.className = 'toast';
  node.setAttribute('role', tone === 'error' ? 'alert' : 'status');
  node.setAttribute('aria-live', tone === 'error' ? 'assertive' : 'polite');
  node.textContent = message;

  document.body.appendChild(node);
  active = node;

  timer = setTimeout(dismiss, duration);
  return node;
}

export function dismiss() {
  if (timer) clearTimeout(timer);
  timer = null;
  if (active) active.remove();
  active = null;
}
